import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as React from "react";
export const ExplicitlyShownPopupContext = /*#__PURE__*/React.createContext(undefined);
ExplicitlyShownPopupContext.displayName = "ExplicitlyShownPopupContext";
export const LayerGroupContext = /*#__PURE__*/React.createContext(undefined);
LayerGroupContext.displayName = "LayerGroupContext";
export const ModalPopupContext = /*#__PURE__*/React.createContext(undefined);
ModalPopupContext.displayName = "ModalPopupContext";
export const AbPopupContext = /*#__PURE__*/React.createContext(undefined);
AbPopupContext.displayName = "AbPopupContext";
export const withAbPopupContext = Base => {
  const WithPopupContextHoc = props => {
    const context = React.useContext(AbPopupContext);
    return /*#__PURE__*/React.createElement(Base, _extends({}, props, {
      popupContext: context
    }));
  };
  return WithPopupContextHoc;
};
//# sourceMappingURL=PopupContext.js.map
